import React, { useCallback, useEffect, useState } from "react";
import { Box, Container, Popover, TextField, Typography,Stack,Button, Snackbar, Alert, useTheme} from "@mui/material";
import { useTranslation } from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";
import {  AccessTime,  ArrowDownward, NotificationsNone, DeleteForeverOutlined, Add } from "@mui/icons-material";
import {  ContractStatusKeys, ModeOfSigningKeys, formatDate, getLocalStorageItem, setLocalStorageItem } from "../../_helpers";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useSelector } from "react-redux";
import CreateContractDrawer from "./Components/CreateContractDrawer";
import { cancelContract, deleteContracts, getAllContracts, sendReminder, setProlong } from "../../apis/contractApis";
import ConfirmBox from './../../components/ConfirmBox';
import DataGridV2 from "../../components/DataGridV2";
import { apps, LOCAL_STORAGE_GRID_KEYS } from "../../_constants";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import { INITIAL_ROW_SELECTION_MODEL } from "../../components/DataGridV2/constants";
import { getContractOverviewColumns } from "./contractOverviewUtils";
import { useMemo } from "react";
import { getIdsForGridSelectedRows } from "../../_helpers/getIdsForGridSelectedRows";

const ContractOverview = () => {

  const classes = useStyles();
  const history = useHistory();
  const apiRef = useGridApiRef();
  const theme = useTheme()
 const app = useSelector((state) => state.app);
  const { t , i18n} = useTranslation();
  const [contract, setContract] = useState({
    loading:false,
    data:[]
  });
  const [toast, setToast] = React.useState({open:false, message:null, type:""})
  const [openGenerateContact, setOpenGenerateContact] = useState(false);
  const [isValidContractAction, setIsValidContractAction] = useState(false)
  const [isValidDeleteContractAction, setIsValidDeleteContractAction] = useState(false)
  const { selected, rights, all:allBuildings} = useSelector(state => state.buildings)
  const [selectedRows, setSelectedRows] = useState([])
  const [prolongDays, setProlongDays] = useState()
  const keyPrefix = app === apps.huisinfo ? "BUYERS_GUIDE" : "GENERAL";
  const [anchorEl, setAnchorEl] = useState(null);
  const [isMenuOpenInMobile, setIsMenuOpenInMobile] = useState(null);
  const [isOpenConfirmBox, setisOpenConfirmBox] = useState({
    open:false,
    for:undefined
  })
  const [rowSelectionModel, setRowSelectionModel] = useState(INITIAL_ROW_SELECTION_MODEL);
  const [paginationModel, setPaginationModel] = useState(() => getLocalStorageItem(
          LOCAL_STORAGE_GRID_KEYS.CONTRACT_OVERVIEW_LIST_PAGINATION[keyPrefix], undefined
      ))
  
  const [loading, setLoading] = useState({
    reminder: false,
    prolong: false,
    withdraw: false,
    delete: false
  })


  const handleAnchorElOpen  = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleAnchorElClose  = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handleGenerateContractDrawer = () => {
    setOpenGenerateContact(!openGenerateContact)
  }

  const handleRowClick = (params) => {
    const contractId = params.row?.id;
    if (contractId) {
      history.push("/contract/"+ contractId);
    }
  };
  const handleProlong = async () => {
    try {
      setLoading({ ...loading, prolong: true })
      await Promise.all(selectedRows?.map((item)=>  setProlong(item?.contractId, prolongDays?.toString())))
   
      setToast({ open: true, message: t("general.prolong.success"), type: "success" })
      setAnchorEl(null);
      setIsMenuOpenInMobile(null);

    } catch (e) {
      console.log(e)
      setToast({ open: true, message: t("error.header"), type: "error" })
    } finally {
      setLoading({ ...loading, prolong: false })

    }
  }


  const handleReminder = async () => {
    try {
      setLoading({ ...loading, reminder: true })
      await Promise.all(selectedRows?.map((item)=> sendReminder(item?.contractId)))
      
      setToast({ open: true, message: t("contract.details.timeLine.reminder.success"), type: "success" })
      setIsMenuOpenInMobile(null);

    } catch (e) {
      console.log(e)
      setToast({ open: true, message: t("error.header"), type: "error" })
    } finally {
      setLoading({ ...loading, reminder: false })

    }
  }

  const fetchContracts = async (loading = true)=>{
    try{
      if(selected.projectId){
      setContract({data:[] , loading})
      const response=  await getAllContracts([selected.projectId])
      const data = response?.data?.map((item)=>{
        const building = allBuildings.find((building) => building?.buildingId?.toLowerCase() === item?.buildingId?.toLowerCase())
        if(!building){
          return item
        }
        return {...item,id:item.contractId, projectNo:building.projectNo,projectName :building.projectName,  objectNumber : building.buildingNoIntern,creationDate:item.creationDate ? formatDate(new Date(item.creationDate), true) : '',  expiryDate : item.expiryDate ?formatDate(new Date(item.expiryDate), true) : '',modeOfSigning :t("contract.signatureType."+item.signatureType),scriveId: item.scriveDocumentId,scriveStatus:item.scriveDocumentStatus, status : item.status  }
      }) || []
       setContract({data:data, loading:false})
      }
    }catch(e){
      console.log(e)
      setContract({data:[], loading:false})
    }
  }
const scriveStatuses = [...new Set(contract?.data.map(c => c.scriveStatus).filter(Boolean))];
const columns = getContractOverviewColumns({t,theme,keyPrefix,i18n,apiRef,scriveStatuses})

const handleWithdraw = async () => {
    try {
      setLoading({ ...loading, withdraw: true })
      setisOpenConfirmBox({open:false,for:undefined})
      await Promise.all(selectedRows?.map((item)=> cancelContract(item?.contractId)))
      await fetchContracts();
      setToast({ open: true, message: t("general.withdraw.success"), type: "success" })
      setIsMenuOpenInMobile(null);
    } catch (e) {
      console.log(e)
      setToast({ open: true, message: t("error.header"), type: "error" })
    } finally {
      setLoading({ ...loading, withdraw: false })
    }
  }


  const handleCloseSnackbar = ()=>{
    setToast({open:false, message:null, type:"success"})
  }

  const handleDelete = async ()=>{
    try {
      setLoading({ ...loading, delete: true })
      setisOpenConfirmBox({open:false,for:undefined})

      await deleteContracts({data:selectedRows?.map((item)=> item?.contractId)})
      setIsMenuOpenInMobile(null);
      await fetchContracts()
      setToast({ open: true, message: t("contract.delete.success"), type: "success" })
    } catch (e) {
      console.log(e)
      setToast({ open: true, message: t("error.header"), type: "error" })
    } finally {
      setLoading({ ...loading, delete: false })
    }
  }
  
      const onPaginationModelChange = useCallback((newPaginationModel) => {
          setPaginationModel(newPaginationModel)
          setLocalStorageItem(
              LOCAL_STORAGE_GRID_KEYS.CONTRACT_OVERVIEW_LIST_PAGINATION[keyPrefix],
              newPaginationModel
          );
      }, [keyPrefix])
  
  const contractIds = useMemo(() => {
    return getIdsForGridSelectedRows(rowSelectionModel, contract?.data)
  }, [rowSelectionModel, contract?.data]);

  const getToolbarProps = useMemo(() => {
    const hasSelectedRows = contractIds.length > 0;

    const toolbarProps = {
      toolbarStartActions: [
        {
          title: t("general.add"),
          icon: Add,
          onClick: handleGenerateContractDrawer,
          disabled: !rights["contract.canCreateContract"]
        }
      ],
      taskMenuListItems: hasSelectedRows ? [
        {
          title: t("contract.details.timeLine.sendReminder"),
          icon: (props) => <NotificationsNone {...props} />,
          onClick: handleReminder,
          disabled: !isValidContractAction,
        },
        {
          title: t("contract.details.timeLine.prolong"),
          icon: (props) => <AccessTime {...props} />,
          onClick: handleAnchorElOpen ,
          disabled: !isValidContractAction,
        },
        {
          title: t("contract.details.timeLine.withdraw"),
          icon: (props) => <ArrowDownward {...props} />,
          onClick: () => setisOpenConfirmBox({ open: true, for: "withdraw" }),
          disabled: !isValidContractAction,
        },
        {
          title: t("general.delete"),
          icon: (props) => <DeleteForeverOutlined {...props} />,
          onClick: () => setisOpenConfirmBox({ open: true, for: "delete" }),
          disabled: !isValidDeleteContractAction,
        },
      ] : [],
    };
    return toolbarProps;
  }, [rowSelectionModel, t, handleGenerateContractDrawer, rights, isValidContractAction, isValidDeleteContractAction]);

  useEffect(()=>{
    fetchContracts()
  },[selected.projectId])

   const getContractOverViewForPrintAndDownload = ({ isAllSelected = true, idsToExport = [] }) => {
      const userSelectedRows = isAllSelected ? contract?.data: idsToExport.map(id => contract?.data.find(item => item?.id === id));
      const results = userSelectedRows?.map(item => {
      const result = {};
      Object.keys(item).forEach(key => {
        let value = item[key];
        const isDateTimeField = columns.some(x => x.field === key && x.type === 'dateTime');

                 if (isDateTimeField) {
                    value = item[key] ? formatDate(new Date(item[key]), true) : ""; 
                  } 
                   else if (key === "status") {
                    value = value !== undefined ? t(`contract.status.${value}`) : "";
                  }
             result[key] = value;
      });
  
      return result;
    });
  
    return results;
  };
  return (
    <>
      <Container maxWidth={false} className={classes.mainContainer}>
        <DataGridV2
          localSearchIdentifier={LOCAL_STORAGE_GRID_KEYS.CONTRACT_OVERVIEW_LIST_SEARCH_TEXT[keyPrefix]}
          localColumnFilterIdentifier={LOCAL_STORAGE_GRID_KEYS.CONTRACT_OVERVIEW_LIST_COLUMN_FILTER[keyPrefix]}
          localColumnSortIdentifier={LOCAL_STORAGE_GRID_KEYS.CONTRACT_OVERVIEW_LIST_COLUMN_SORT[keyPrefix]}
          localColumnOrderIdentifier={LOCAL_STORAGE_GRID_KEYS.CONTRACT_OVERVIEW_LIST_COLUMN_ORDER[keyPrefix]}
          localColumnWidthIdentifier={LOCAL_STORAGE_GRID_KEYS.CONTRACT_OVERVIEW_LIST_COLUMN_WIDTH[keyPrefix]}
          localColumnVisibilityIdentifier={LOCAL_STORAGE_GRID_KEYS.CONTRACT_OVERVIEW_LIST_COLUMN_VISIBILITY[keyPrefix]}
          apiRef={apiRef}
          loading={contract.loading}
          checkboxSelection
          rows={contract?.data}
          columns={columns}
          toolbarProps={{
            ...getToolbarProps,
            selectedRows: rowSelectionModel,
            getData: getContractOverViewForPrintAndDownload,
            title: t("general.contract"),
          }}
          onRowClick={handleRowClick}
          pagination
          rowSelectionModel={rowSelectionModel}
          {...(!!paginationModel && { paginationModel })}
          onPaginationModelChange={onPaginationModelChange}
          filterMode="client"
          onRowSelectionModelChange={(newRowSelectionModel) => {
            setRowSelectionModel(newRowSelectionModel);
            const selectedIds = getIdsForGridSelectedRows(newRowSelectionModel, contract?.data);
            const selectedItems = contract?.data?.filter((item) =>
              selectedIds.includes(item.id)
            ) || [];
            const isValidContractAction = selectedItems.every(
              (item) =>
                item?.status === ContractStatusKeys.WaitingForSign &&
                item?.signatureType !== ModeOfSigningKeys.PrintAndSign
            );
            const isDeleteAllowed = selectedItems.every((item) =>   [ContractStatusKeys.New, ContractStatusKeys.InProgress].includes(item?.status) );
            setIsValidContractAction(isValidContractAction && selectedItems.length > 0);
            setIsValidDeleteContractAction(isDeleteAllowed && selectedItems.length > 0);
            if (isValidContractAction || isDeleteAllowed) {
              setSelectedRows(selectedItems);
            } else {
              setSelectedRows([]);
            }
          }}
        />
        <CreateContractDrawer openGenerateContact={openGenerateContact} handleGenerateContractDrawer={handleGenerateContractDrawer} />
      </Container>
       <ConfirmBox open={isOpenConfirmBox.open && isOpenConfirmBox.for === "delete"} title={t("general.warning")} description={t("contract.delete.warning.description")} okText={t("general.confirm")} cancelText={t("general.cancel")} onOk={handleDelete}
            onCancel={() => setisOpenConfirmBox({ open: false, for: undefined })} />
       <ConfirmBox open={isOpenConfirmBox.open && isOpenConfirmBox.for === "withdraw"} title={t("general.warning")} description={t("contract.details.timeLine.withdraw.warning.description")} okText={t("general.confirm")} cancelText={t("general.cancel")} onOk={handleWithdraw}
              onCancel={() => setisOpenConfirmBox({ open: false, for: undefined })} />

        <Popover
          sx={{ mt: 1 }}
          open={open} 
          anchorEl={anchorEl}
          onClose={handleAnchorElClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Box
            sx={{
              maxWidth: 275,
              p: 1.5
            }}>
            <Typography variant="caption">{t("general.popover.title")}</Typography>
            <TextField
              sx={{ mt: 2 }}
              fullWidth
              label={t("general.days")}
              type="number"
              size='small'
              onChange={(e)=>{
                const val = e.target.value
                 if(!val){
                  setProlongDays("")
                 }
                 const numberValue = Number(val)
                 if(numberValue <= 99 && numberValue>0){
                  setProlongDays(numberValue)
                 }
               }}
              value={prolongDays?.toString()}
              slotProps={{
                input: {
                inputProps: { 
                    max: 99, min: 1
                }
               },

                inputLabel: {
                  shrink: true,
                }
              }} />
            <Stack
              direction="row"
              sx={{
                columnGap: 1,
                mt: 2,
                justifyContent: "center"
              }}>
              <Button variant="outlined" onClick={handleAnchorElClose}>{t("general.cancel")}</Button>
              <Button loading={loading.prolong} variant="contained" onClick={handleProlong}>{t("general.confirm")}</Button>
            </Stack>
          </Box>
        </Popover>
    <Snackbar
        open={toast.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={toast.type || "success"}
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </>
  )
}


const useStyles = makeStyles((theme) => ({
  "@global": {
    ".MuiButtonBase-root:focus": {
      outline: 0,
    },
  },
  mainContainer: {
    height:"100%",
    overflow: "auto",
    padding: 0,
  },
  grow: {
    flexGrow: 1,
  },
  fullWidth: {
    width: "100%",
  },
  headerTitleContainer: {
    display: "flex",
    alignItems: "center",
  },
  headerTitleSubContainer: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    "-webkit-line-clamp": 1,
    "-webkit-box-orient": "vertical",
  },
  headerTitle: {
    color: theme.palette.grey[800],
    fontWeight: 500,
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "-webkit-line-clamp": 1,
    "-webkit-box-orient": "vertical",
    whiteSpace: "nowrap",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  greenText: {
    color: theme.palette.success.main,
  },
}));

export { ContractOverview }
